import React from "react";
import { Box } from "@mui/material";
import { ThreeDot } from "react-loading-indicators";

function InProgress() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <ThreeDot color="#e55426" size="small" text="" textColor="" />
      {/* <Typography
        variant="h5"
        sx={{
          marginTop: "20px",
          color: "#333",
        }}
      >
        This feature is in progress. Please check back later.
      </Typography> */}
    </Box>
  );
}

export default InProgress;
